import React, { useState } from 'react';
import { Search, Send, Paperclip, Archive, Trash2, Filter, Star } from 'lucide-react';
import './EmailMailsView.scss';

const INITIAL_EMAILS = [
    {
        id: 1,
        from: 'campaigns@acme.com',
        name: 'ACME Marketing',
        subject: '🎉 Exclusive: 50% OFF Black Friday Early Access',
        preview: 'Get early access to our biggest sale of the year! Limited time offer...',
        time: '10:30 AM',
        unread: true,
        starred: false,
        messages: [
            { id: 1, text: '🎉 BLACK FRIDAY EARLY ACCESS - 50% OFF! 🎉\n\nYou\'re one of our VIP customers, so we\'re giving you early access to our biggest sale of the year!\n\n⏰ Offer valid: TODAY only\n✨ Discount: 50% OFF everything\n🚚 FREE shipping on all orders\n\n👉 Claim Your Discount → [Shop Now]\n\nThis exclusive offer expires at midnight!\n\nHappy shopping!\n- ACME Team', sender: 'ACME Marketing', time: '10:30 AM', isMe: false },
            { id: 2, text: 'Thanks for the early access! This is a great deal. I\'m checking out your winter collection.', sender: 'You', time: '10:45 AM', isMe: true },
            { id: 3, text: 'You\'re welcome! Thank you for being a loyal customer. Don\'t forget - offer expires at midnight!', sender: 'ACME Marketing', time: '11:00 AM', isMe: false },
        ]
    },
    {
        id: 2,
        from: 'support@saasapp.io',
        name: 'SaaS App Team',
        subject: 'New Feature Alert: AI-Powered Dashboard',
        preview: 'Introducing our latest innovation - AI analytics that works for you...',
        time: '09:15 AM',
        unread: true,
        starred: true,
        messages: [
            { id: 1, text: '🚀 NEW FEATURE ANNOUNCEMENT 🚀\n\nWe\'re thrilled to announce the launch of our AI-Powered Dashboard!\n\n✨ What\'s New:\n📊 Smart data insights with AI\n🎯 Automated reporting\n💡 Predictive recommendations\n⚡ 10x faster analysis\n\n🎁 Early adopters get 3 MONTHS FREE!\n\n👉 Try it now → [Launch App]\n\nBest regards,\nSaaS App Team', sender: 'SaaS App Team', time: '09:15 AM', isMe: false },
            { id: 2, text: 'This sounds amazing! How does the AI analytics work with my current data?', sender: 'You', time: '09:30 AM', isMe: true },
            { id: 3, text: 'Great question! The AI seamlessly analyzes your existing data and learns your patterns. No migration needed!', sender: 'SaaS App Team', time: '09:45 AM', isMe: false },
        ]
    },
    {
        id: 3,
        from: 'newsletter@techblog.com',
        name: 'TechBlog Weekly',
        subject: 'Weekly Digest: Top 10 Productivity Tools of 2025',
        preview: 'Our curated list of the best tools to boost your productivity...',
        time: 'Yesterday',
        unread: false,
        starred: false,
        messages: [
            { id: 1, text: '📬 WEEKLY DIGEST: TOP TOOLS OF 2025 📬\n\nHi there!\n\nThis week we\'ve compiled our list of the 10 most game-changing productivity tools:\n\n1. AI Writing Assistant\n2. Project Management Suite\n3. Time Tracking Tool\n...and 7 more!\n\nRead the full article with reviews → [Read Now]\n\nHappy optimizing!\nTechBlog Team', sender: 'TechBlog Weekly', time: 'Yesterday 2:00 PM', isMe: false },
            { id: 2, text: 'Thanks for the recommendations! I especially liked the writing assistant review.', sender: 'You', time: 'Yesterday 2:15 PM', isMe: true },
        ]
    },
    {
        id: 4,
        from: 'events@company.com',
        name: 'Company Events',
        subject: 'You\'re Invited: Virtual Summit - The Future of AI',
        preview: 'Join industry experts for our exclusive virtual summit...',
        time: 'Yesterday',
        unread: false,
        starred: false,
        messages: [
            { id: 1, text: '🎤 VIRTUAL SUMMIT INVITATION 🎤\n\nYou\'re Invited!\n\nJoin us for "The Future of AI" - an exclusive virtual summit with industry leaders!\n\n📅 Date: Friday, Jan 24\n🕐 Time: 10 AM - 2 PM EST\n🎯 Topics: AI Trends, Automation, Future of Work\n👥 Speakers: 5 Top Industry Experts\n🎁 Free attendance + Resource Kit\n\n✨ BONUS: Register before Friday and get exclusive discount code for our platform!\n\nRegister now → [Sign Up]\n\nSpots filling fast!\n\nBest,\nCompany Events Team', sender: 'Company Events', time: 'Yesterday 10:00 AM', isMe: false },
            { id: 2, text: 'Sounds great! I\'ll register for the summit. Are there any networking opportunities?', sender: 'You', time: 'Yesterday 10:30 AM', isMe: true },
        ]
    },
    {
        id: 5,
        from: 'rewards@store.com',
        name: 'Loyalty Rewards',
        subject: '⭐ You have 5,000 points - Redeem Today!',
        preview: 'Your loyalty points are expiring soon - claim your rewards now...',
        time: 'Jan 10',
        unread: false,
        starred: false,
        messages: [
            { id: 1, text: '⭐ LOYALTY REWARDS ALERT ⭐\n\nHey! You have 5,000 loyalty points ready to redeem!\n\n💳 Your points expire in 30 days\n\nRedeem for:\n🎁 Free products\n🛍️ Exclusive discounts\n⭐ Early access to sales\n🚚 Free shipping\n\nDon\'t let your points expire!\n\nRedeem now → [Claim Rewards]\n\nThanks for being awesome!\nLoyalty Team', sender: 'Loyalty Rewards', time: 'Jan 10 3:00 PM', isMe: false },
        ]
    },
];

function EmailMailsView() {
    const [emails, setEmails] = useState(INITIAL_EMAILS);
    const [selectedEmail, setSelectedEmail] = useState(INITIAL_EMAILS[0]);
    const [searchQuery, setSearchQuery] = useState('');
    const [showUnreadOnly, setShowUnreadOnly] = useState(false);
    const [replyText, setReplyText] = useState('');

    const filteredEmails = emails.filter(email => {
        const matchesSearch = email.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                            email.subject.toLowerCase().includes(searchQuery.toLowerCase());
        const matchesUnread = !showUnreadOnly || email.unread;
        return matchesSearch && matchesUnread;
    });

    const handleSelectEmail = (email) => {
        setSelectedEmail(email);
        setEmails(emails.map(e =>
            e.id === email.id ? { ...e, unread: false } : e
        ));
    };

    const handleSendReply = () => {
        if (!replyText.trim()) return;

        setEmails(emails.map(email => {
            if (email.id === selectedEmail.id) {
                const updatedEmail = {
                    ...email,
                    messages: [
                        ...email.messages,
                        {
                            id: email.messages.length + 1,
                            text: replyText,
                            sender: 'You',
                            time: new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }),
                            isMe: true
                        }
                    ]
                };
                setSelectedEmail(updatedEmail);
                return updatedEmail;
            }
            return email;
        }));

        setReplyText('');
    };

    const handleToggleStar = (emailId) => {
        setEmails(emails.map(email =>
            email.id === emailId ? { ...email, starred: !email.starred } : email
        ));
        if (selectedEmail.id === emailId) {
            setSelectedEmail({ ...selectedEmail, starred: !selectedEmail.starred });
        }
    };

    const unreadCount = emails.filter(e => e.unread).length;

    return (
        <div className="email-mails-root">
            <div className="email-mails-list">
                <div className="email-mails-header">
                    <div>
                        <h2>Inbox</h2>
                        {unreadCount > 0 && <span className="unread-badge">{unreadCount}</span>}
                    </div>
                </div>
                <div className="email-mails-search">
                    <Search className="email-mails-search-icon" size={16} />
                    <input
                        type="text"
                        placeholder="Search emails..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                    />
                </div>
                <div className="email-mails-filter">
                    <button
                        className={`filter-toggle ${showUnreadOnly ? 'active' : ''}`}
                        onClick={() => setShowUnreadOnly(!showUnreadOnly)}
                    >
                        <Filter size={16} />
                        Unread
                    </button>
                </div>
                <div className="email-mails-items">
                    {filteredEmails.length > 0 ? (
                        filteredEmails.map((email) => (
                            <div
                                key={email.id}
                                onClick={() => handleSelectEmail(email)}
                                className={`email-mails-item ${selectedEmail.id === email.id ? 'active' : ''} ${email.unread ? 'unread' : ''}`}
                            >
                                <div className="email-mails-item-star">
                                    <Star
                                        size={16}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            handleToggleStar(email.id);
                                        }}
                                        className={email.starred ? 'filled' : ''}
                                    />
                                </div>
                                <div className="email-mails-item-info">
                                    <div className="email-mails-item-header">
                                        <h4>{email.name}</h4>
                                        <span>{email.time}</span>
                                    </div>
                                    <div className="email-mails-item-subject">{email.subject}</div>
                                    <div className="email-mails-item-preview">{email.preview}</div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="email-mails-empty">
                            <p>No emails found</p>
                        </div>
                    )}
                </div>
            </div>
            <div className="email-mails-panel">
                <div className="email-mails-header-section">
                    <div>
                        <h3>{selectedEmail.subject}</h3>
                        <p>{selectedEmail.name} &lt;{selectedEmail.from}&gt;</p>
                    </div>
                    <div className="email-mails-actions">
                        <button>
                            <Archive size={20} />
                        </button>
                        <button>
                            <Trash2 size={20} />
                        </button>
                    </div>
                </div>
                <div className="email-mails-messages">
                    {selectedEmail.messages.map((msg) => (
                        <div key={msg.id} className={`email-mails-message ${msg.isMe ? 'me' : ''}`}>
                            <div className="email-message-sender">{msg.sender}</div>
                            <div className="email-message-time">{msg.time}</div>
                            <div className="email-message-content">{msg.text}</div>
                        </div>
                    ))}
                </div>
                <div className="email-mails-reply">
                    <textarea
                        placeholder="Write your reply..."
                        value={replyText}
                        onChange={(e) => setReplyText(e.target.value)}
                    />
                    <div className="email-mails-reply-actions">
                        <button className="reply-attach">
                            <Paperclip size={18} />
                            Attach
                        </button>
                        <button
                            className="reply-send"
                            disabled={!replyText.trim()}
                            onClick={handleSendReply}
                        >
                            <Send size={18} />
                            Send
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EmailMailsView;
